import React from 'react'

import Receive from './receive'

import SendPatientFor from '../drawers/sendPatientFor'

const SendFor = ({ loading, error, department="OutPatient", title, source, attachedTo, patient, groups, group, tab }) => {
    return (
        <Receive
            progress
            loading={loading}
            error={error}>
            <SendPatientFor {...{ source, department, title, groups, group, tab, attachedTo, patient }} />
        </Receive>
    )
}

export default SendFor